import { useAppSelector } from "../../../old/beheer/store";
import { selectSalesAreaId } from "../../SalesAreas/selectors/selectSalesAreaId";
import { useFetchVoucherDefinitionsQuery } from "../../Vouchers/api/voucherDefinitionApi";
import { useFormContext } from "react-hook-form";
import { CircularProgress, FormControl, InputLabel, MenuItem, Select } from "@mui/material";
import React from "react";

export default function PickVoucherDefinition() {
  const { register } = useFormContext<{ rewardable_id: string }>();
  const salesAreaId = useAppSelector(selectSalesAreaId);
  const { data, isFetching } = useFetchVoucherDefinitionsQuery(
    { vestiging_id: salesAreaId ?? 0, pagination: { page: 0, perPage: 250 } },
    { skip: (salesAreaId ?? 0) === 0 }
  );

  if (isFetching) {
    return <CircularProgress />;
  }
  return (
    <FormControl fullWidth={true}>
      <InputLabel>Voucher definition</InputLabel>
      <Select label={"Voucher definition"} {...register("rewardable_id")}>
        {data?.data?.map((voucherDefinition) => {
          return (
            <MenuItem key={voucherDefinition.id} value={voucherDefinition.id}>
              {voucherDefinition.title} #{voucherDefinition.id}
            </MenuItem>
          );
        })}
      </Select>
    </FormControl>
  );
}
